"use strict";

/**
 * Academy Swiper – Shared slider init for academy sections.
 * Each [data-academy-swiper] section gets its own Swiper instance.
 */
(function () {
  function initSection(section) {
    var container = section.querySelector('.swiper');
    var prevBtn = section.querySelector('[data-slider-prev]');
    var nextBtn = section.querySelector('[data-slider-next]');
    var btnWrap = section.querySelector('.academy-slider-buttons');
    if (!container) return;
    var slidesPerViewMobile = parseFloat(section.dataset.slidesPerView || '1.15');
    var slidesPerViewTablet = parseFloat(section.dataset.slidesPerViewTb || '2.15');
    var slidesPerViewDesktop = parseFloat(section.dataset.slidesPerViewMd || '3');
    var spaceBetweenMobile = parseInt(section.dataset.spaceBetween || '16', 10);
    var spaceBetweenDesktop = parseInt(section.dataset.spaceBetweenMd || '20', 10);
    var slidesOffset = parseInt(section.dataset.slidesOffset || '0', 10);
    // Optional start/end inset that also survives the ≥768 / ≥1024 breakpoints
    // (the plain data-slides-offset is reset to 0 there). Opt-in per section –
    // absent → 0, so existing sections are unaffected.
    var slidesOffsetMd = parseInt(section.dataset.slidesOffsetMd || '0', 10);
    // When set (value = the page's centered content-column max-width in px, e.g.
    // 1440), the *start* inset grows so the first slide lines up with that
    // column instead of sitting a plain gutter from the screen edge. Below that
    // width it collapses back to the plain offset, so the carousel still bleeds
    // to the edge while scrolling. Recomputed on resize.
    var offsetAlignWidth = parseInt(section.dataset.slidesOffsetAlign || '0', 10);
    var PAGE_MARGIN = 20; // #main-content left/right padding – see _container.scss

    function alignedOffset(base) {
      if (!offsetAlignWidth) return base;
      var edge = Math.round((window.innerWidth - offsetAlignWidth) / 2 + PAGE_MARGIN);
      return Math.max(base, edge);
    }

    var loop = section.dataset.loop === 'true';
    var scaleEffect = container.dataset.scaleEffect === 'true';
    var dotsEl = section.dataset.dots === 'true' ? section.querySelector('.swiper-pagination') : null;
    var centered = section.dataset.centered === 'true';
    var mousewheel = section.dataset.mousewheel === 'true';

    // Swiper's native loop mode duplicates/reorders real DOM nodes internally, and
    // combined with slidesPerView:'auto' + centeredSlides this has proven unreliable
    // (wrong initial position, one-directional wraparound, cloned slides losing
    // per-instance overrides). For centered carousels we instead pad the real
    // slide list with server-rendered clone slides (see the section liquid) and
    // silently snap back into the real range once a transition lands on a clone —
    // Swiper only ever sees ordinary, non-looping slides.
    var manualLoop = section.dataset.manualLoop === 'true';
    var realCount = parseInt(section.dataset.realCount || '0', 10);
    var cloneBuffer = parseInt(section.dataset.cloneBuffer || '0', 10);

    var swiper = new Swiper(container, {
      slidesPerView: centered ? 'auto' : slidesPerViewMobile,
      centeredSlides: centered,
      spaceBetween: spaceBetweenMobile,
      slidesOffsetBefore: alignedOffset(slidesOffset),
      slidesOffsetAfter: slidesOffset,
      initialSlide: manualLoop ? cloneBuffer : 0,
      loop: manualLoop ? false : loop,
      loopAdditionalSlides: (!manualLoop && loop) ? 12 : 0,
      watchSlidesProgress: scaleEffect,
      grabCursor: true,
      mousewheel: mousewheel ? { forceToAxis: true } : false,
      breakpoints: {
        768: {
          slidesPerView: centered ? 'auto' : slidesPerViewTablet,
          spaceBetween: spaceBetweenDesktop,
          slidesOffsetBefore: alignedOffset(slidesOffsetMd),
          slidesOffsetAfter: slidesOffsetMd
        },
        1024: {
          slidesPerView: centered ? 'auto' : slidesPerViewDesktop,
          spaceBetween: spaceBetweenDesktop,
          slidesOffsetBefore: alignedOffset(slidesOffsetMd),
          slidesOffsetAfter: slidesOffsetMd
        }
      },
      navigation: prevBtn && nextBtn ? {
        prevEl: prevBtn,
        nextEl: nextBtn
      } : false,
      pagination: dotsEl ? {
        el: dotsEl,
        clickable: true
      } : false,
      a11y: {
        enabled: true,
        prevSlideMessage: 'Vorherige Folie',
        nextSlideMessage: 'Nächste Folie',
        firstSlideMessage: 'Dies ist die erste Folie',
        lastSlideMessage: 'Dies ist die letzte Folie',
        paginationBulletMessage: 'Zu Folie {{index}} springen',
        slideLabelMessage: 'Folie {{index}} von {{slidesLength}}'
      }
    });

    // Keep the aligned start inset in sync with the viewport. Swiper's
    // breakpoint system rewrites slidesOffsetBefore from the plain md value on
    // every resize, so we re-apply the aligned value afterwards.
    if (offsetAlignWidth) {
      swiper.on('resize', function () {
        var base = window.innerWidth >= 768 ? slidesOffsetMd : slidesOffset;
        swiper.params.slidesOffsetBefore = alignedOffset(base);
        swiper.update();
      });
    }

    if (manualLoop && realCount > 0) {
      swiper.on('slideChangeTransitionEnd', function () {
        var idx = swiper.activeIndex;
        if (idx < cloneBuffer || idx >= cloneBuffer + realCount) {
          var real = ((idx - cloneBuffer) % realCount + realCount) % realCount;
          var target = cloneBuffer + real;

          // The jump itself is instant, but the target slide was previously
          // inactive (scaled down) — without this, it visibly "pops" up to
          // full scale over the card's normal 0.45s transition right as the
          // position snaps, reading as a stutter. Suppress that one transition.
          var inners = container.querySelectorAll('.academy-featured-bike-cards__slide-inner, .academy-age-selector__card');
          inners.forEach(function (el) { el.style.transition = 'none'; });

          swiper.slideTo(target, 0, false);

          void container.offsetHeight; // force reflow before re-enabling
          requestAnimationFrame(function () {
            inners.forEach(function (el) { el.style.transition = ''; });
          });
        }
      });
    }

    if (scaleEffect) {
      var prevVisible = new Set();

      swiper.on('beforeTransitionStart', function () {
        prevVisible = new Set(Array.from(swiper.visibleSlides));
      });

      swiper.on('slideChangeTransitionStart', function () {
        swiper.visibleSlides.forEach(function (slide) {
          if (!prevVisible.has(slide)) {
            slide.classList.remove('is-entering');
            // Force reflow so the animation restarts if the same slide re-enters
            void slide.offsetWidth;
            slide.classList.add('is-entering');
          }
        });
      });

      swiper.on('slideChangeTransitionEnd', function () {
        swiper.slides.forEach(function (slide) {
          slide.classList.remove('is-entering');
        });
      });
    }

    // Hide arrows + dots when every slide already fits (nothing to scroll)

    function updateButtons() {
      var locked = swiper.isLocked;
      if (btnWrap) btnWrap.style.display = locked ? 'none' : '';
      if (dotsEl) dotsEl.style.display = locked ? 'none' : '';
    }

    swiper.on('resize', updateButtons);
    swiper.on('lock', updateButtons);
    swiper.on('unlock', updateButtons);
    updateButtons();
  }

  function initPartnersSection(wrapper) {
    var container = wrapper.querySelector('.swiper');
    if (!container) return;
    var speed = parseInt(wrapper.dataset.speed || '6000', 10);
    var swiper = new Swiper(container, {
      slidesPerView: 'auto',
      spaceBetween: 0,
      loop: true,
      speed: speed,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
        pauseOnMouseEnter: true
      },
      // Logos load via lazysizes (class="lazyload"), not Swiper's own
      // built-in lazy loading — Swiper's `updateOnImagesReady` only knows
      // about its own system, so with slidesPerView:'auto' it was measuring
      // each slide's width from whatever was on screen at init (often still
      // the tiny lazysizes placeholder or an unloaded image with no
      // intrinsic size yet). One slide's width then stayed wrong/huge for
      // the rest of that page view once the real logo swapped in later —
      // "ein Logo nimmt die ganze Viewport-Breite ein". observer:true makes
      // Swiper re-measure via MutationObserver whenever a slide's attributes
      // change, which lazysizes triggers (swaps src/srcset, adds the
      // lazyloaded class) — so it corrects itself the moment each logo
      // actually loads.
      observer: true,
      observeParents: true,
      // Continuously scrolling logo marquee. The partner links keep their own
      // aria-label and stay in the tab order, but Swiper's a11y live-region is
      // disabled here – on an infinite autoplay marquee it would fire a slide
      // announcement on every step and flood the screen reader.
      a11y: { enabled: false }
    });
    // Belt-and-suspenders: force one explicit update per logo as it
    // finishes loading, in case a MutationObserver edge case is missed
    // (e.g. the image was already cached and lazysizes swaps it in
    // synchronously before the observer has attached).
    Array.prototype.forEach.call(wrapper.querySelectorAll('img.lazyload'), function (img) {
      img.addEventListener('lazyloaded', function () { swiper.update(); });
    });
  }

  document.querySelectorAll('[data-academy-swiper]').forEach(initSection);
  document.querySelectorAll('[data-academy-partners-swiper]').forEach(initPartnersSection); // Shopify theme editor support

  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      var section = e.target;

      if (section.querySelector('[data-academy-swiper]')) {
        initSection(section.querySelector('[data-academy-swiper]'));
      }

      if (section.querySelector('[data-academy-partners-swiper]')) {
        initPartnersSection(section.querySelector('[data-academy-partners-swiper]'));
      }
    });
  }
})();